/**
 * Tutor students detail tab.
 * Paired students as navigable cards (name, program, manager).
 */
import * as React from 'react';
import { GraduationCap } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { DetailsCard } from '@/components/common/DetailsCard';
import { DetailField } from '@/components/common/details/DetailField';

/** Paired student shown on the remote tutor students tab. */
interface AccompaniedStudent {
  binomeId: string;
  studentUserId: string;
  name: string;
  program?: string | null;
  managedByName: string;
}

/** Props for {@link TutorStudentsTab}. */
interface TutorStudentsTabProps {
  accompaniedStudents: AccompaniedStudent[];
}

/** Tutor students detail tab. */
export const TutorStudentsTab: React.FC<TutorStudentsTabProps> = ({ accompaniedStudents }) => {
  const navigate = useNavigate();

  return (
    <div className="details-view-grid mt-6">
      {accompaniedStudents.length === 0 ? (
        <p className="text-sm text-muted-foreground">Aucun élève associé</p>
      ) : (
        accompaniedStudents.map((s) => (
          <button
            key={s.binomeId}
            type="button"
            className="section-card-compact appearance-none border-0 bg-transparent p-0 text-left cursor-pointer"
            onClick={() =>
              navigate(`/students?view=${s.studentUserId}`, {
                state: { personName: s.name },
              })
            }
          >
            <DetailsCard
              icon={GraduationCap}
              title={s.name}
              colorName="color-3"
              className="h-full cursor-pointer"
            >
              <DetailField label="Nom" value={s.name} />
              {s.program ? <DetailField label="Programme" value={s.program} /> : null}
              <DetailField label="Géré par" value={s.managedByName} />
            </DetailsCard>
          </button>
        ))
      )}
    </div>
  );
};
